var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    [
      _c(
        "v-navigation-drawer",
        {
          staticStyle: { "z-index": "350" },
          attrs: { temporary: "", absolute: "" },
          model: {
            value: _vm.sideNav,
            callback: function($$v) {
              _vm.sideNav = $$v
            },
            expression: "sideNav"
          }
        },
        [
          _c(
            "div",
            { staticClass: "sideNav" },
            [
              _c(
                "v-list",
                { staticClass: "pa-1" },
                [
                  _vm.userIsAuthanticated && _vm.user_role == "business"
                    ? _c(
                        "v-list-tile",
                        { attrs: { avatar: "" } },
                        [
                          _vm.signed_in_user_avatar != null
                            ? _c("v-list-tile-avatar", [
                                _c("img", {
                                  attrs: { src: _vm.signed_in_user_avatar }
                                })
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.signed_in_user_avatar == null
                            ? _c(
                                "v-list-tile-avatar",
                                { attrs: { color: "primary" } },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "white--text headline" },
                                    [_vm._v(_vm._s(this.initial))]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", [
                                _vm._v(_vm._s(this.signed_in_business))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.userIsAuthanticated && _vm.user_role == "artist"
                    ? _c(
                        "v-list-tile",
                        { attrs: { avatar: "" } },
                        [
                          _vm.signed_in_user_avatar != null
                            ? _c(
                                "v-list-tile-avatar",
                                { attrs: { size: _vm.avatarSize } },
                                [
                                  _c("img", {
                                    attrs: { src: _vm.signed_in_user_avatar }
                                  })
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.signed_in_user_avatar == null
                            ? _c(
                                "v-list-tile-avatar",
                                { attrs: { color: "primary" } },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "white--text headline" },
                                    [_vm._v(_vm._s(this.artist_initial))]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            {
                              staticStyle: { "font-size": "14px" },
                              attrs: { flex: "" }
                            },
                            [
                              _vm.check_if_artist_has_entered_instagram
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "v-list-tile-title",
                                        {
                                          staticStyle: { "margin-left": "10px" }
                                        },
                                        [_vm._v(_vm._s(this.artist_name))]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "buttons" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/upload_an_image1" } },
                    [
                      _vm.userIsAuthanticated && _vm.user_role == "artist"
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "black",
                                dark: "",
                                large: "",
                                depressed: ""
                              }
                            },
                            [_vm._v("\n           Upload Art")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              this.$store.getters.user != null
                ? _c(
                    "v-container",
                    [
                      this.$store.getters.user.id ==
                        "H2kEJMbkyxUhcAfKH1jcMeDOn442" ||
                      this.$store.getters.user.id ==
                        "b8Yc6Iz0ktV6ofVC1lHgCJ3EQCn1"
                        ? _c(
                            "v-btn",
                            {
                              attrs: { flat: "", small: "", to: "/dashboard" }
                            },
                            [_vm._v("Admin\n      ")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-list",
                { staticClass: "pt-0 hidden-md-and-up", attrs: { dense: "" } },
                _vm._l(_vm.navItems, function(item) {
                  return _c(
                    "v-list-tile",
                    { key: item.title, attrs: { to: item.link } },
                    [
                      _c(
                        "v-list-tile-action",
                        [_c("v-icon", [_vm._v(_vm._s(item.icon))])],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile-content",
                        [_c("v-list-tile-title", [_vm._v(_vm._s(item.title))])],
                        1
                      )
                    ],
                    1
                  )
                })
              ),
              _vm._v(" "),
              _c(
                "v-list",
                { staticClass: "pt-0", attrs: { dense: "" } },
                [
                  _vm._l(_vm.sideNavItems, function(item) {
                    return _c(
                      "v-list-tile",
                      { key: item.title, attrs: { to: item.link } },
                      [
                        _c(
                          "v-list-tile-action",
                          [_c("v-icon", [_vm._v(_vm._s(item.icon))])],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-list-tile-content",
                          { attrs: { light: "" } },
                          [
                            _c("v-list-tile-title", [
                              _vm._v(_vm._s(item.title))
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _vm.userIsAuthanticated && _vm.user_role == "business"
                    ? _c(
                        "v-list-tile",
                        [
                          _c(
                            "v-list-tile-action",
                            [_c("v-icon", [_vm._v("forum")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            { attrs: { light: "" } },
                            [
                              _c(
                                "router-link",
                                { attrs: { to: "/submissions" } },
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v("Your submissions")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.userIsAuthanticated && _vm.user_role == "artist"
                    ? _c(
                        "v-list-tile",
                        [
                          _c(
                            "v-list-tile-action",
                            [_c("v-icon", [_vm._v("mail")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            { attrs: { light: "" } },
                            [
                              _c(
                                "router-link",
                                { attrs: { to: "/new_reviews" } },
                                [
                                  _c(
                                    "v-list-tile-tile",
                                    { on: { click: function($event) {} } },
                                    [_vm._v("Reviews ")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.userIsAuthanticated && _vm.user_role == "artist"
                    ? _c(
                        "v-list-tile",
                        [
                          _c(
                            "v-list-tile-action",
                            [_c("v-icon", [_vm._v("chat")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            { attrs: { light: "" } },
                            [
                              _c(
                                "router-link",
                                { attrs: { to: "/chat" } },
                                [
                                  _c(
                                    "v-list-tile-tile",
                                    { on: { click: function($event) {} } },
                                    [_vm._v("Chat ")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-list-tile",
                    [
                      _vm.userIsAuthanticated
                        ? _c(
                            "v-chip",
                            {
                              staticStyle: { width: "160px" },
                              attrs: {
                                flat: "",
                                color: "primary",
                                "text-color": "white"
                              },
                              on: {
                                click: function($event) {
                                  _vm.$router.push("/account")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n      Freebie Credits     :    " +
                                  _vm._s(this.$store.state.free_credits) +
                                  "\n    "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-tile",
                    [
                      _vm.userIsAuthanticated
                        ? _c(
                            "v-chip",
                            {
                              staticStyle: { width: "160px" },
                              attrs: {
                                flat: "",
                                color: "primary",
                                "text-color": "white"
                              },
                              on: {
                                click: function($event) {
                                  _vm.$router.push("/account")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n      Premium Credits: " +
                                  _vm._s(this.$store.state.credits) +
                                  "\n    "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "v-toolbar",
        {
          staticStyle: {
            "background-color": "white",
            height: "100px",
            "padding-top": "18px"
          },
          attrs: { flat: "" }
        },
        [
          _c("v-spacer", { staticStyle: { "max-width": "20px" } }),
          _vm._v(" "),
          _vm.userIsAuthanticated
            ? _c("v-toolbar-side-icon", {
                on: {
                  click: function($event) {
                    _vm.sideNav = !_vm.sideNav
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.userIsAuthanticated && this.$store.state.user_role == "artist"
            ? _c(
                "router-link",
                {
                  staticStyle: { cursor: "pointer" },
                  attrs: { to: "/artist_dashboard", tag: "span" }
                },
                [
                  _c("v-avatar", [
                    _c("img", {
                      attrs: {
                        src: "/static/images/logo.png",
                        height: "40px",
                        alt: "SYA Logo"
                      }
                    })
                  ])
                ],
                1
              )
            : _vm.userIsAuthanticated &&
              this.$store.state.user_role == "business"
              ? _c(
                  "router-link",
                  {
                    staticStyle: { cursor: "pointer" },
                    attrs: { to: "/business_dashboard", tag: "span" }
                  },
                  [
                    _c("v-avatar", [
                      _c("img", {
                        attrs: {
                          src: "/static/images/logo.png",
                          height: "40px",
                          alt: "SYA Logo"
                        }
                      })
                    ])
                  ],
                  1
                )
              : _c(
                  "router-link",
                  {
                    staticStyle: { cursor: "pointer" },
                    attrs: { to: "/", tag: "span" }
                  },
                  [
                    _c("v-avatar", [
                      _c("img", {
                        attrs: {
                          src: "/static/images/logo.png",
                          height: "40px",
                          alt: "SYA Logo"
                        }
                      })
                    ])
                  ],
                  1
                ),
          _vm._v(" "),
          _vm.screen_breakpoint_2
            ? _c("v-toolbar-title", { staticClass: "large-logo" }, [
                _c("p", [_vm._v("SIYA")])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-toolbar-items",
            { staticStyle: { "padding-top": "25px" } },
            [
              _vm.userIsAuthanticated && this.$store.state.user_role == "artist"
                ? _c(
                    "p",
                    {
                      staticClass: "body-1 mr-5",
                      staticStyle: { cursor: "pointer" },
                      on: {
                        click: function($event) {
                          _vm.$router.push("/blogs")
                        }
                      }
                    },
                    [_vm._v("\n          Blogs/Magazines\n        ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.userIsAuthanticated && this.$store.state.user_role == "artist"
                ? _c(
                    "p",
                    {
                      staticClass: "body-1 mr-5",
                      staticStyle: { cursor: "pointer" },
                      on: { click: _vm.route_to }
                    },
                    [_vm._v("\n          Submit Your Work\n        ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.navItems, function(item) {
                return _vm.screen_breakpoint
                  ? _c(
                      "div",
                      {
                        key: item.title,
                        staticClass: "body-1 mr-5",
                        staticStyle: { cursor: "pointer" },
                        on: {
                          click: function($event) {
                            _vm.$router.push(item.link)
                          }
                        }
                      },
                      [
                        !item.spacing
                          ? _c("p", [_vm._v(_vm._s(item.title))])
                          : _vm._e(),
                        _vm._v(" "),
                        item.spacing && !_vm.userIsAuthanticated
                          ? _c(
                              "p",
                              { staticStyle: { "margin-left": "50px" } },
                              [_vm._v(_vm._s(item.title))]
                            )
                          : _vm._e()
                      ]
                    )
                  : _vm._e()
              }),
              _vm._v(" "),
              !_vm.userIsAuthanticated && !_vm.screen_breakpoint
                ? _c(
                    "p",
                    {
                      staticClass: "mr-5",
                      staticStyle: { cursor: "pointer" },
                      on: {
                        click: function($event) {
                          _vm.$router.push("/sign_in")
                        }
                      }
                    },
                    [_vm._v("\n          Sign In | Sign Up\n        ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.userIsAuthanticated
                ? _c(
                    "v-menu",
                    {
                      staticStyle: {
                        "margin-top": "-10px",
                        "margin-left": "-20px"
                      }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticStyle: { width: "40px", height: "40px" },
                          attrs: { slot: "activator", icon: "" },
                          slot: "activator"
                        },
                        [_c("v-icon", [_vm._v("more_vert")])],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list",
                        { staticStyle: { width: "200px" } },
                        [
                          _c(
                            "v-list-tile",
                            [
                              _c(
                                "router-link",
                                {
                                  staticStyle: { cursor: "pointer" },
                                  attrs: { to: "/support", tag: "span" }
                                },
                                [_c("v-list-tile-title", [_vm._v("Support")])],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            [
                              _c(
                                "router-link",
                                {
                                  staticStyle: { cursor: "pointer" },
                                  attrs: { to: "/about_us", tag: "span" }
                                },
                                [_c("v-list-tile-title", [_vm._v("About Us")])],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            [
                              _c(
                                "router-link",
                                {
                                  staticStyle: { cursor: "pointer" },
                                  attrs: { to: "/profile", tag: "span" }
                                },
                                [_c("v-list-tile-title", [_vm._v("Profile")])],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            [
                              _c(
                                "router-link",
                                {
                                  staticStyle: { cursor: "pointer" },
                                  attrs: { to: "/", tag: "span" }
                                },
                                [
                                  _c(
                                    "v-list-tile-title",
                                    { on: { click: _vm.onSignOut } },
                                    [_vm._v("Sign Out")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "main",
        [
          _c(
            "v-layout",
            { attrs: { row: "" } },
            [
              _vm.userIsAuthanticated
                ? _c("v-flex", { attrs: { xs9: "" } }, [_c("router-view")], 1)
                : _c("v-flex", { attrs: { xs12: "" } }, [_c("router-view")], 1),
              _vm._v(" "),
              _vm.userIsAuthanticated
                ? _c(
                    "v-flex",
                    { attrs: { "hidden-md-and-down": "", xs3: "" } },
                    [
                      _vm.userIsAuthanticated
                        ? _c(
                            "v-card",
                            { attrs: { flat: "" } },
                            [
                              _c(
                                "p",
                                {
                                  staticClass: "subheading mb-1",
                                  staticStyle: {
                                    "font-weight": "bold",
                                    color: "black !important"
                                  }
                                },
                                [_vm._v("Recently Submitted Artists")]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                _vm._l(12, function(index) {
                                  return _c(
                                    "v-flex",
                                    {
                                      key: index,
                                      attrs: {
                                        xs12: "",
                                        "mt-1": "",
                                        "mb-1": ""
                                      }
                                    },
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          staticStyle: { cursor: "pointer" },
                                          on: {
                                            click: function($event) {
                                              _vm.go_to_viewed_artist_page(
                                                index
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs2: "" } },
                                            [
                                              _c("v-avatar", [
                                                _c("img", {
                                                  attrs: {
                                                    src:
                                                      _vm.top_12_recent_art[
                                                        index
                                                      ].art.url
                                                  }
                                                })
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            { attrs: { xs10: "", "ml-2": "" } },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass: "subheading mt-1"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.top_12_recent_art[
                                                        index
                                                      ].art.art_title
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                {
                                                  staticClass: "body-1",
                                                  staticStyle: {
                                                    "margin-top": "-20px"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.top_12_recent_art[
                                                        index
                                                      ].art.artist_name
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                })
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-footer",
        {
          staticStyle: { "background-color": "#e5e5e5" },
          attrs: { height: "auto" }
        },
        [
          _c(
            "v-layout",
            {
              attrs: {
                "justify-center": "",
                row: "",
                wrap: "",
                "mt-5": "",
                "mb-4": "",
                "ml-4": "",
                "mr-4": ""
              }
            },
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass: "ml-3 mr-3",
                  staticStyle: { cursor: "pointer", color: "#676d6a" },
                  on: {
                    click: function($event) {
                      _vm.$router.push("/about_us")
                    }
                  }
                },
                [_vm._v("\n          About\n        ")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass: "ml-3 mr-3",
                  staticStyle: { cursor: "pointer", color: "#676d6a" },
                  on: {
                    click: function($event) {
                      _vm.$router.push("/support")
                    }
                  }
                },
                [_vm._v("\n          Support / FAQs\n        ")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "ml-3 mr-3",
                  staticStyle: { cursor: "pointer", color: "#676d6a" },
                  attrs: {
                    href:
                      "mailto:nick@shareyourselfartists.com?Subject=Support",
                    target: "_top"
                  }
                },
                [_vm._v("\n          Contact\n        ")]
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                {
                  staticStyle: {
                    "background-color": "#e5e5e5",
                    color: "#676d6a"
                  },
                  attrs: { "text-xs-left": "", xs12: "" }
                },
                [
                  _c("v-avatar", [
                    _c("img", {
                      attrs: {
                        src: "/static/images/logo.png",
                        height: "40px",
                        alt: "SYA Logo"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "mt-2", staticStyle: { color: "#676d6a" } },
                    [
                      _vm._v(
                        "\n          © Copyright 2018 Share Yourself Artists\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 